import {
  MerchantSetupProductSchema,
  MerchantSetupProgressSchema,
} from "@redotech/redo-onboarding-db-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * Bidirectional. The provider calls this whenever the set of "complete
 * required-for-live tasks" transitions across the boundary — both when
 * crossing into complete (sets completed_at) and when regressing back
 * to incomplete (clears completed_at). Idempotent within a state.
 */
export const setMerchantSetupGuideCompletion = {
  name: "setMerchantSetupGuideCompletion" as const,
  input: z.object({
    product: MerchantSetupProductSchema,
    completed: z.boolean(),
  }),
  output: zExt.filterToValid(MerchantSetupProgressSchema),
};
